import { render, staticRenderFns } from "./GestionnaireRelevesPorteur.vue?vue&type=template&id=2d941f8a&"
import script from "./GestionnaireRelevesPorteur.js?vue&type=script&lang=js&"
export * from "./GestionnaireRelevesPorteur.js?vue&type=script&lang=js&"
import style0 from "./GestionnaireRelevesPorteur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports